module.exports = __webpack_public_path__ + "static/assets/174cbb7cc72418e5f095e0b734ceed1d.svg";